<template>
  <div class="mt-4">
    <custom-callout
      v-for="item in summary"
      :key="item.ageGroupDescription"
      class="mt-2"
      :opened="false"
      class-panel="bg-white"
    >
      <label class="title p-2 font-weight-normal">
        <span class="font-weight-bold">
          Estudiantes de {{ item.ageGroupDescription }} años -
        </span>
        Resumen de Alternativa de Ubicación
      </label>
      <template #edition>
        <div
          v-for="subItem in item.list"
          :key="subItem.description"
          class="mt-3 p-3 bg-secondary-3"
        >
          <div class="row ">
            <div class="col-md-4">
              <p class="mt-3 ml-5 pl-md-2 font-14 item-description">
                {{ subItem.description }}
              </p>
            </div>
            <div class="col-sm">
              <p class="text-center font-14 font-weight-normal mb-0">
                Cantidad Actual
              </p>
              <p class="text-center mt-1">
                {{ subItem.totalChildCount }}
              </p>
            </div>
            <div class="col-md-4">
              <p class="text-center font-14 font-weight-normal mb-0">
                Cantidad del Año Anterior
              </p>
              <p class="text-center mt-1">
                {{ subItem.lastYearDifferenceCount }}
              </p>
            </div>
            <div class="col-sm ">
              <p class="text-center mt-3">
                <span
                  :class="badgeClass(subItem.difference)"
                  class="rounded-pill  font-14 font-weight-normal text-light mt-3  px-2 py-1 "
                >
                  {{ Math.round(subItem.difference) }}%
                </span>
              </p>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout'
export default {
  name: 'SummaryByCategory',
  components: { CustomCallout },
  props: {
    summary: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    badgeClass(percent) {
      if (percent > 9) return 'bg-danger'

      return 'bg-success'
    },
  },
}
</script>
<style>
@media (max-width: 763px) {
  .item-description {
    text-align: center !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
